
// //Designed By Gaurav Singh on 01/07/2023
// import React, { useEffect, useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   IconButton,
//   InputAdornment,
//   Stack,
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { loginUser } from "../Services/AuthService";
// import { setSession, getSession, clearSession } from "../utils/Session";
// import Swal from "sweetalert2";
// interface LoginPageProps {
//   setUser: React.Dispatch<React.SetStateAction<boolean>>;
// }
// const LoginPage: React.FC<LoginPageProps> = ({ setUser }) => {
//   const [userId, setUserID] = useState<string>("");
//   const [password, setPassword] = useState<string>("");
//   const [showPassword, setShowPassword] = useState<boolean>(false);
//   const [error, setError] = useState<string | null>(null);
//   const [loading, setLoading] = useState<boolean>(false);
//   const navigate = useNavigate();

//   // useEffect(() => {
//   //   if (localStorage.getItem("token")) {
//   //     navigate("/dashboard", { replace: true });
//   //   }
//   // }, []);
//   useEffect(() => {
//     const session = getSession();
//     if (session?.token) {
//       setUser(true);
//       navigate("/dashboard", { replace: true });
//     }
//     // else {
//     //   setUser(false);
//     //   navigate("/", { replace: true }); // Redirect to login page
//     // }
//   }, [navigate, setUser]);

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setError(null);
//     setLoading(true);
//     try {
     
//       const loginResponse = await loginUser({ userId, password });
//       localStorage.setItem("accessToken", loginResponse.accessToken);
//       localStorage.setItem("refreshToken", loginResponse.refreshToken);
//       localStorage.setItem("orgId", loginResponse.user.orgId);
//       localStorage.setItem("orgName", loginResponse.user.orgName);
//       localStorage.setItem("userId", loginResponse.user.userId);
//         // Save session with expiry and user info
//       setSession(loginResponse);
//        // ⭐ Show license warning if exists
//     if (loginResponse?.warning) {
//       Swal.fire({
//         icon: "warning",
//         title: "License Expiry Warning",
//         text: loginResponse.warning,
//         confirmButtonText: "OK",
//       });
//     }
//       setUser(true);
//       navigate("/dashboard");
//     } catch (err: any) {
//       setError(err.message || "Login failed");
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <Box
//       display="flex"
//       justifyContent="center"
//       alignItems="center"
//       minHeight="100vh"
//       bgcolor="#f4f6f8"
//       px={2}
//     >
//       <Box
//         component="form"
//         onSubmit={handleSubmit}
//         maxWidth={400}
//         width="100%"
//         p={4}
//         boxShadow={3}
//         bgcolor="white"
//         borderRadius={2}
//       >
//         <Typography variant="h5" mb={3} fontWeight="bold" textAlign="center">
//           Organization Login
//         </Typography>

//         <Stack spacing={2}>
//           <TextField
//             label="User ID"
//             value={userId}
//             onChange={(e) => setUserID(e.target.value)}
//             fullWidth
//             required
//           />

//           <TextField
//             label="Password"
//             type={showPassword ? "text" : "password"}
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             fullWidth
//             required
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton
//                     onClick={() => setShowPassword((prev) => !prev)}
//                     edge="end"
//                   >
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <Box display="flex" justifyContent="flex-end">
//             <Typography
//               variant="body2"
//               component={Link}
//               to="/forgot-password"
//               color="primary"
//               sx={{
//                 textDecoration: "none",
//                 "&:hover": { textDecoration: "underline" },
//               }}
//             >
//               Forgot Password?
//             </Typography>
//           </Box>

//           {error && (
//             <Typography color="error" variant="body2">
//               {error}
//             </Typography>
//           )}

//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             fullWidth
//             disabled={loading}
//           >
//             {loading ? "Logging in..." : "Login"}
//           </Button>

//           <Typography variant="body2" textAlign="center">
//             Don’t have an organization profile?{" "}
//             <Link to="/OrgProfileForm">Set up your organization</Link>
//           </Typography>
//         </Stack>
//       </Box>
//     </Box>
//   );
// };

// export default LoginPage;
import React, { useEffect, useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useSubscription } from "../Hooks/useSubscription";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Swal from "sweetalert2";
 
import { loginUser }               from "../Services/AuthService";
import { setSession, getSession }  from "../utils/Session";
 
// ─── Types ────────────────────────────────────────────────────────────────────
 
interface LoginPageProps {
  setUser: React.Dispatch<React.SetStateAction<boolean>>;
}
 
// ─── Component ────────────────────────────────────────────────────────────────
 
const LoginPage: React.FC<LoginPageProps> = ({ setUser }) => {
  const [userId,       setUserID]       = useState<string>("");
  const [password,     setPassword]     = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [error,        setError]        = useState<string | null>(null);
  const [loading,      setLoading]      = useState<boolean>(false);
 const { refreshSubscription } = useSubscription();
  const navigate          = useNavigate();
  const [searchParams]    = useSearchParams();
 
  // ── If already logged in, skip login page ────────────────────────────────
  useEffect(() => {
    const session = getSession();
    // FIX: setSession stores the full response; check accessToken not token
    if (session?.accessToken) {
      setUser(true);
      navigate("/dashboard", { replace: true });
    }
  }, [navigate, setUser]);
 
  // ── FIX: Show "session expired" banner when axiosInstance redirects here ──
  useEffect(() => {
    if (searchParams.get("session") === "expired") {
      Swal.fire({
        icon:              "warning",
        title:             "Session Expired",
        text:              "Your session has expired. Please log in again.",
        confirmButtonText: "OK",
      });
    }
  }, [searchParams]);
 
  // ── Submit ────────────────────────────────────────────────────────────────
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
 
    try {
      const loginResponse = await loginUser({
        userId:   userId.trim(),   // FIX: trim whitespace
        password,
      });
 
      // ── Persist tokens + user info ────────────────────────────────────
      localStorage.setItem("accessToken",  loginResponse.accessToken);
      localStorage.setItem("refreshToken", loginResponse.refreshToken);
      localStorage.setItem("orgId",        loginResponse.user.orgId);
      localStorage.setItem("orgName",      loginResponse.user.orgName);
      localStorage.setItem("userId",       loginResponse.user.userId);
 
      // FIX: store orgDetails so axiosInstance / PDF generator can use it
      // as a fallback even if the /api/org call fails
      // (fetched fresh from backend on dashboard load; this is just a cache)
      // If your loginResponse includes orgDetails, store it:
      // localStorage.setItem("orgDetails", JSON.stringify(loginResponse.orgDetails));
 
      // ── Save full session (used by getSession() guard) ────────────────
      setSession(loginResponse);
      // ── NEW: now that accessToken exists in localStorage, tell the
      // subscription provider to fetch for real (its initial mount ran
      // before login, with no token, and skipped itself on purpose).
      await refreshSubscription();
      // ── License expiry warning ────────────────────────────────────────
      // AuthService normalises warningMessage → warning
      if (loginResponse?.warning) {
        Swal.fire({
          icon:              "warning",
          title:             "License Expiry Warning",
          text:              loginResponse.warning,
          confirmButtonText: "OK",
        });
      }
 
      setUser(true);
      navigate("/dashboard");
 
    } catch (err: any) {
      setError(err.message || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };
 
  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f4f6f8"
      px={2}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        maxWidth={400}
        width="100%"
        p={4}
        boxShadow={3}
        bgcolor="white"
        borderRadius={2}
      >
        <Typography variant="h5" mb={3} fontWeight="bold" textAlign="center">
          Organization Login
        </Typography>
 
        <Stack spacing={2}>
          <TextField
            label="User ID"
            value={userId}
            onChange={(e) => setUserID(e.target.value)}
            fullWidth
            required
            autoComplete="username"
            inputProps={{ autoCapitalize: "none" }}
            InputLabelProps={{ shrink: true }}
          />
 
          <TextField
            label="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            required
            autoComplete="current-password"
            InputLabelProps={{ shrink: true }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword((p) => !p)}
                    edge="end"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
 
          <Box display="flex" justifyContent="flex-end">
            <Typography
              variant="body2"
              component={Link}
              to="/forgot-password"
              color="primary"
              sx={{
                textDecoration: "none",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Forgot Password?
            </Typography>
          </Box>
 
          {error && (
            <Typography color="error" variant="body2" role="alert">
              {error}
            </Typography>
          )}
 
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading || !userId.trim() || !password}
          >
            {loading ? "Logging in..." : "Login"}
          </Button>
 
          <Typography variant="body2" textAlign="center">
            Don't have an organization profile?{" "}
            <Link to="/OrgProfileForm">Set up your organization</Link>
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
 
export default LoginPage;
